import { fromPostgrest, guard, type Result } from '@/lib/result';
import { supabase } from '@/lib/supabase';

import { mapCertification, type Certification } from '../model/certification';

const WITH_CERTIFIER = '*, certifier:profiles!certifier_id(full_name)';

export const certificationsRepository = {
  /** Active (non-revoked) certifications a freelancer has received. */
  async listForFreelancer(freelancerId: string): Promise<Result<readonly Certification[]>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('certifications')
        .select(WITH_CERTIFIER)
        .eq('freelancer_id', freelancerId)
        .is('revoked_at', null)
        .order('created_at', { ascending: false });
      if (error) throw fromPostgrest(error);
      return ((data ?? []) as unknown[]).map(mapCertification);
    });
  },

  async create(
    freelancerId: string,
    certifierId: string,
    note: string | null,
  ): Promise<Result<Certification>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('certifications')
        .insert({ certifier_id: certifierId, freelancer_id: freelancerId, note })
        .select(WITH_CERTIFIER)
        .single();
      if (error) throw fromPostgrest(error);
      return mapCertification(data as unknown);
    });
  },
};
